import { jsxs, jsx } from 'react/jsx-runtime';
import { Flex, font, themedColor, Box, usePageScroll, useViewportSize } from '@lemonade-hq/cdk';
import { Logo, MEDIA_QUERIES } from '@lemonade-hq/nuis';
import { useContext, useState, useMemo, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import styled, { css } from 'styled-components';
import { getHeaderLinksByCountryAndRegion } from '../../helpers/links.esm.js';
import { urlWithPreventRedirect } from '../../helpers/routes.esm.js';
import { CommonI18nContext } from '../../providers/I18nProvider.esm.js';
import { NavContext } from '../../providers/NavProvider.esm.js';
import { AppHeaderDropdown } from './internals/AppHeaderDropdown.esm.js';
import { BurgerMenu } from './internals/BurgerMenu.esm.js';
import { HeaderContentLinks } from './internals/HeaderContentLinks.esm.js';
import { headerMediaBreakpoint } from './internals/shared.esm.js';
export { AccountDropdownOptionsSettings } from './internals/shared.esm.js';
import { useUserContext } from '../../providers/UserProvider.esm.js';
import { Cookie } from '../../config/cookies.esm.js';

/* eslint-disable @typescript-eslint/naming-convention */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  height: 100%;\n  left: 50%;\n  top: 0;\n  transform: translateX(-50%);\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n          transform: scale(0.8) translateY(0);\n        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n      transition: transform 0.2s;\n      width: ",
        "px;\n      transform: scale(1) translateY(33px);\n\n      ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n      transition: opacity;\n      transition-duration: ",
        ";\n      transition-delay: ",
        ";\n      opacity: ",
        ";\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  width: ",
        "px;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n      display: none;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n  display: block;\n  position: absolute;\n  right: ",
        ";\n  color: ",
        ";\n  text-decoration: none;\n  white-space: nowrap;\n  padding: 10px 14px;\n\n  ",
        "\n\n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    transform: translateY(-15px);\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n      height: 100px;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n          height: ",
        "px;\n      "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n      border-bottom: 1px solid ",
        ";\n\n      ",
        "\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: ",
        "px;\n  background-color: ",
        ";\n  border-bottom: 1px solid transparent;\n  z-index: 100;\n  padding-left: 0;\n  transition: height 0.2s;\n\n  ",
        "\n\n  @media ",
        " {\n    padding-left: 25px;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  display: none;\n\n  @media ",
        " {\n    display: block;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  align-self: flex-start;\n  height: ",
        "px;\n\n  position: relative;\n  align-items: center;\n\n  button {\n    padding-bottom: 10px;\n    padding-top: 10px;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n      ",
        ";\n  "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  margin-left: 5px;\n  display: block;\n  position: absolute;\n  right: ",
        ";\n  text-decoration: none;\n  white-space: nowrap;\n  padding: ",
        ";\n  -webkit-tap-highlight-color: transparent;\n\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  transition: transform ",
        "ms cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  transform: ",
        ";\n  margin-left: 5px;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n      visibility: hidden;\n      pointer-events: none;\n    "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
var FIXED_HEADER_OFFSET = 60;
var MOBILE_LOGO_WIDTH = 116;
var LOGO_WIDTH = 146;
var CTA_TRANSITION_DURATION = 300;
var HEADER_HEIGHT = 70;
var LogoContainer = styled(Flex)(_templateObject());
var StyledLogo = styled(Logo)(_templateObject4(), MOBILE_LOGO_WIDTH, MEDIA_QUERIES.desktop(_templateObject2(), LOGO_WIDTH, function(param) {
    var fixedState = param.fixedState;
    return fixedState && css(_templateObject1());
}), MEDIA_QUERIES.mobile(_templateObject3(), function(param) {
    var hideMobileLogo = param.hideMobileLogo;
    return hideMobileLogo ? "0s" : "0.2s";
}, function(param) {
    var hideMobileLogo = param.hideMobileLogo;
    return hideMobileLogo ? "0s" : "0.2s";
}, function(param) {
    var hideMobileLogo = param.hideMobileLogo;
    return hideMobileLogo ? "0" : "1";
}));
var StyledLink = styled.a(_templateObject6(), font("main", {
    fontSize: "1.6rem",
    lineHeight: 1.3
}), function(param) {
    var moved = param.moved;
    return moved ? "100%" : 0;
}, themedColor("night"), MEDIA_QUERIES.mobile(_templateObject5()));
var HeaderContainer = styled(Flex)(_templateObject10(), HEADER_HEIGHT, function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, MEDIA_QUERIES.desktop(_templateObject7()), headerMediaBreakpoint, function(props) {
    return props.fixedState && css(_templateObject9(), function(param) {
        var theme = param.theme;
        return theme.colors.light;
    }, MEDIA_QUERIES.desktop(_templateObject8(), HEADER_HEIGHT));
});
var NavMenu = styled(Box)(_templateObject11(), headerMediaBreakpoint);
var ActionContainer = styled(Flex)(_templateObject12(), HEADER_HEIGHT);
var AppHeaderDropdownContainer = styled(Flex)(_templateObject14(), function(param) {
    var moved = param.moved;
    return moved ? "100%" : "0";
}, function(param) {
    var moved = param.moved;
    return moved ? "10px 20px 10px 14px" : "10px 13px 10px 14px";
}, MEDIA_QUERIES.mobile(_templateObject13(), function(param) {
    var moved = param.moved;
    return moved ? "padding-right: 16px" : "padding-right: 0px";
}));
var AdditionalCTAContainer = styled.div(_templateObject15(), CTA_TRANSITION_DURATION, function(param) {
    var show = param.show;
    return show ? "translateY(0)" : "translateY(-100px)";
});
var StyledBurgerMenu = styled(BurgerMenu)(_templateObject17(), function(param) {
    var showBurgerMenu = param.showBurgerMenu;
    return !showBurgerMenu && css(_templateObject16());
});
var Header = function(_param) {
    var links = _param.links, _param_showLogo = _param.showLogo, showLogo = _param_showLogo === void 0 ? true : _param_showLogo, _param_showLogin = _param.showLogin, showLogin = _param_showLogin === void 0 ? false : _param_showLogin, _param_showUserAccount = _param.showUserAccount, showUserAccount = _param_showUserAccount === void 0 ? false : _param_showUserAccount, _param_showBurgerMenu = _param.showBurgerMenu, showBurgerMenu = _param_showBurgerMenu === void 0 ? true : _param_showBurgerMenu, routerHoc = _param.routerHoc, additionalCTA = _param.additionalCTA, showAdditionalCTA = _param.showAdditionalCTA, trackingContext = _param.trackingContext, accountDropdownOptionsSettings = _param.accountDropdownOptionsSettings, _param_fixed = _param.fixed, fixed = _param_fixed === void 0 ? false : _param_fixed, _param_disableLogoLink = _param.disableLogoLink, disableLogoLink = _param_disableLogoLink === void 0 ? false : _param_disableLogoLink, firstName = _param.firstName, lastName = _param.lastName, _param_showLinks = _param.showLinks, showLinks = _param_showLinks === void 0 ? true : _param_showLinks, props = _object_without_properties(_param, [
        "links",
        "showLogo",
        "showLogin",
        "showUserAccount",
        "showBurgerMenu",
        "routerHoc",
        "additionalCTA",
        "showAdditionalCTA",
        "trackingContext",
        "accountDropdownOptionsSettings",
        "fixed",
        "disableLogoLink",
        "firstName",
        "lastName",
        "showLinks"
    ]);
    var _useUserContext = useUserContext(), contextUser = _useUserContext.user;
    var t = useContext(CommonI18nContext).t;
    var nav = useContext(NavContext).nav;
    var _useState = _sliced_to_array(useState(null), 2), AdditionalCTA = _useState[0], setAdditionalCTA = _useState[1];
    var absoluteScroll = usePageScroll().absoluteScroll;
    var _useState1 = _sliced_to_array(useState(fixed), 2), fixedState = _useState1[0], setFixedState = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), hideMobileLogo = _useState2[0], setHideMobileLogo = _useState2[1];
    var isMobileViewport = useViewportSize().isMobileViewport;
    var _useCookies = _sliced_to_array(useCookies([
        Cookie.Geography
    ]), 1), cookies = _useCookies[0];
    var resolvedLinks = useMemo(function() {
        return links !== null && links !== void 0 ? links : getHeaderLinksByCountryAndRegion(cookies[Cookie.Geography]);
    }, [
        links,
        cookies
    ]);
    var user = useMemo(function() {
        return contextUser != null ? {
            givenName: contextUser.givenName,
            familyName: contextUser.familyName
        } : firstName != null && lastName != null ? {
            givenName: firstName,
            familyName: lastName
        } : null;
    }, [
        contextUser,
        firstName,
        lastName
    ]);
    useEffect(function() {
        if (additionalCTA != null) {
            setAdditionalCTA(additionalCTA);
        }
    }, [
        additionalCTA,
        setAdditionalCTA
    ]);
    useEffect(function() {
        if (!fixed) {
            var nextFixedState = absoluteScroll > FIXED_HEADER_OFFSET;
            if (nextFixedState !== fixedState) {
                setFixedState(nextFixedState);
            }
            if (isMobileViewport && showUserAccount && nextFixedState) {
                setHideMobileLogo(true);
                setAdditionalCTA(additionalCTA);
            }
            if (isMobileViewport && showUserAccount && !nextFixedState) {
                setHideMobileLogo(false);
                setAdditionalCTA(null);
            }
        }
    }, [
        absoluteScroll,
        additionalCTA,
        fixed,
        fixedState,
        hideMobileLogo,
        isMobileViewport,
        showUserAccount
    ]);
    var ContentLinks = useMemo(function() {
        return routerHoc != null ? routerHoc(HeaderContentLinks) : HeaderContentLinks;
    }, [
        routerHoc
    ]);
    return /*#__PURE__*/ jsxs(HeaderContainer, _object_spread_props(_object_spread({
        as: "header",
        fixedState: fixedState,
        justifyContent: "space-between",
        pr: [
            "15px",
            "20px"
        ],
        width: "100%"
    }, props), {
        children: [
            /*#__PURE__*/ jsx(StyledBurgerMenu, {
                links: resolvedLinks,
                routerHoc: routerHoc,
                showBurgerMenu: showBurgerMenu,
                showLogin: showLogin
            }),
            showLinks && /*#__PURE__*/ jsx(NavMenu, {
                children: /*#__PURE__*/ jsx(ContentLinks, {
                    links: resolvedLinks
                })
            }),
            showLogo && /*#__PURE__*/ jsx(LogoContainer, {
                alignItems: "center",
                justifyContent: "center",
                children: disableLogoLink ? /*#__PURE__*/ jsx(StyledLogo, {
                    fixedState: fixedState,
                    hideMobileLogo: hideMobileLogo
                }) : /*#__PURE__*/ jsx("a", {
                    "aria-label": "Lemonade Insurance Company",
                    href: urlWithPreventRedirect(nav.home),
                    title: "Lemonade Insurance Company",
                    children: /*#__PURE__*/ jsx(StyledLogo, {
                        fixedState: fixedState,
                        hideMobileLogo: hideMobileLogo
                    })
                })
            }),
            /*#__PURE__*/ jsxs(ActionContainer, {
                alignItems: "center",
                children: [
                    showLogin && !showUserAccount && /*#__PURE__*/ jsx(StyledLink, {
                        "data-event": "header.login.clicked",
                        href: nav.login,
                        moved: AdditionalCTA != null && showAdditionalCTA,
                        children: t("header.actions.login")
                    }),
                    showUserAccount && user != null && accountDropdownOptionsSettings && /*#__PURE__*/ jsx(AppHeaderDropdownContainer, {
                        moved: AdditionalCTA != null && showAdditionalCTA,
                        children: /*#__PURE__*/ jsx(AppHeaderDropdown, {
                            accountDropdownOptionsSettings: accountDropdownOptionsSettings,
                            firstName: user.givenName,
                            lastName: user.familyName,
                            trackingContext: trackingContext
                        })
                    }),
                    additionalCTA != null && /*#__PURE__*/ jsx(AdditionalCTAContainer, {
                        show: AdditionalCTA != null && showAdditionalCTA,
                        children: AdditionalCTA
                    })
                ]
            })
        ]
    }));
};

export { HEADER_HEIGHT, Header };
